/**
 * Одна операция под собственной арендой черновика.
 *
 * Сервер требует аренду на КАЖДОЙ операции состава: добавлении, переносе,
 * порядке, курьере и подтверждении. Клиент, который просто отправляет запрос,
 * получает отказ на любом черновике, который эта вкладка не открывала, — а
 * черновик, созданный автоматическим расчётом, не принадлежит никому и потому
 * отказывал всегда.
 *
 * Правило, которое здесь закодировано, одно и легко нарушаемое: освобождать
 * можно ТОЛЬКО ту аренду, которую взял сам этот вызов. Сервер отвечает
 * `granted: false`, когда аренда уже принадлежала этой вкладке — значит её
 * держит открытая карточка, и снимать её после чужой операции нельзя: карточка
 * осталась бы открытой без блокировки, а её сердцебиение стучалось бы
 * в пустоту.
 *
 * Отказ захвата наружу не превращается в «ошибку операции»: он и есть ответ —
 * маршрут занят другим редактором. Освобождения в этом случае не происходит.
 */

export interface LeaseScopeDeps {
  /** Захват аренды. `granted: false` означает «аренда уже была нашей». */
  acquire: (routeId: string) => Promise<{ granted: boolean }>;
  /** Освобождение. Best-effort: забытую аренду всё равно снимет истечение. */
  release: (routeId: string) => Promise<void>;
}

export async function withRouteLease<T>(
  deps: LeaseScopeDeps,
  routeId: string,
  operation: () => Promise<T>,
): Promise<T> {
  // Отказ захвата пробрасывается как есть: это ответ сервера о чужой аренде,
  // и подменять его собственным текстом значило бы потерять причину.
  const acquired = await deps.acquire(routeId);

  try {
    return await operation();
  } finally {
    if (acquired.granted) {
      // Отказ освобождения не должен превращать успешную операцию в ошибку:
      // данные уже изменены, а аренда истечёт сама.
      await deps.release(routeId).catch(() => undefined);
    }
  }
}
